import React, { useState, useEffect } from 'react';

const translations = {
  ko: {
    title: "AI 냉장고 매니저 🧊",
    select: "📸 사진 선택 (최대 5장)",
    analyze: "✨ 지금 바로 분석하기",
    analyzing: "✨ AI가 열심히 분석 중입니다...",
    result: "발견된 재료",
    empty: "냉장고가 비어있어요. 사진을 올려주세요!",
    unknownAsk: "🤔 AI가 잘 모르는 재료가 있어요:",
    addManual: "직접 재료 추가하기",
    reminder: "⏰ 리마인더 저장",
    tabHome: "냉장고",
    tabRec: "추천",
    tabSet: "설정",
    historyTitle: "추천 레시피",
    emptyHistory: "아직 추천받은 레시피가 없어요!",
    settingTitle: "앱 설정",
    langMode: "언어 설정",
    themeMode: "테마 설정",
    langToggle: "English로 변경"
  },
  en: {
    title: "AI Fridge Manager 🧊",
    select: "📸 Select Photos (Max 5)",
    analyze: "✨ Analyze Now",
    analyzing: "✨ AI is analyzing...",
    result: "Found Ingredients",
    empty: "Your fridge is empty. Upload photos!",
    unknownAsk: "🤔 AI is not sure about:",
    addManual: "Add Custom",
    reminder: "⏰ Save Reminder",
    tabHome: "Fridge",
    tabRec: "Recipes",
    tabSet: "Settings",
    historyTitle: "Recipe History",
    emptyHistory: "No recipes recommended yet!",
    settingTitle: "App Settings",
    langMode: "Language",
    themeMode: "Theme",
    langToggle: "Change to 한국어"
  }
};

const getInitialLang = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  return browserLang.toLowerCase().includes('ko') ? 'ko' : 'en';
};

const getInitialTheme = () => {
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
};

// 🌟 스티치 디자인: 하단 바 전용 SVG 아이콘 컴포넌트
const Icons = {
  Fridge: ({ active }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={active ? 2 : 1.5} stroke="currentColor" className="w-6 h-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
    </svg>
  ),
  List: ({ active }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={active ? 2 : 1.5} stroke="currentColor" className="w-6 h-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
    </svg>
  ),
  Settings: ({ active }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={active ? 2 : 1.5} stroke="currentColor" className="w-6 h-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  )
};

function App() {
  const [lang, setLang] = useState(getInitialLang);
  const [isDark, setIsDark] = useState(getInitialTheme); 
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ingredients, setIngredients] = useState([]);
  const [unknowns, setUnknowns] = useState([]);
  const [customInput, setCustomInput] = useState('');
  const [activeTab, setActiveTab] = useState('home'); 
  const [recipeHistory, setRecipeHistory] = useState([]);

  const t = translations[lang];
  const isApp = !!window.Capacitor;
  const API_URL = isApp ? "http://ai-fridge.duckdns.org:2047/api" : "/api";

  useEffect(() => {
    const savedHistory = localStorage.getItem('fridgeHistory');
    if (savedHistory) {
      setRecipeHistory(JSON.parse(savedHistory));
    }
  }, []);

  const handleAnalyze = async () => {
    if (images.length === 0) return alert("사진을 선택해주세요!");
    setLoading(true);
    
    const formData = new FormData();
    Array.from(images).forEach(file => formData.append('images', file));
    formData.append('language', lang);

    try {
      const res = await fetch(`${API_URL}/analyze-fridge`, {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();
      setIngredients(data.ingredients || []);
      setUnknowns(data.unknowns || []); 
      
      if (data.recipes && data.recipes.length > 0) {
        const today = new Intl.DateTimeFormat(lang === 'ko' ? 'ko-KR' : 'en-US', { 
          year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' 
        }).format(new Date());

        const newHistoryItem = { date: today, recipes: data.recipes };
        const updatedHistory = [newHistoryItem, ...recipeHistory];
        
        setRecipeHistory(updatedHistory);
        localStorage.setItem('fridgeHistory', JSON.stringify(updatedHistory));
        setActiveTab('recommend');
      }
    } catch (error) {
      alert("분석 중 에러가 발생했습니다.");
    }
    setLoading(false);
  };

  const addCustomIngredient = () => {
    if (customInput.trim() !== '') {
      setIngredients([...ingredients, { name: customInput, status: 'normal', note: '' }]);
      setCustomInput('');
      setUnknowns([]); 
    }
  };

  const saveToReminder = (recipe) => {
    if (navigator.share) {
      navigator.share({
        title: '👨‍🍳 AI 냉장고 레시피',
        text: `[${recipe.name}]\n\n설명: ${recipe.desc}`,
      }).catch(console.error);
    } else {
      alert("공유 미지원 기기입니다.");
    }
  };

  // 🌟 스티치 디자인: 상태별 파스텔톤 태그 스타일 적용
  const getBadgeStyle = (status) => {
    switch(status) {
      case 'expiring': return "border-green-300 text-green-600 bg-green-50";
      case 'warning': return "border-red-300 text-red-500 bg-red-50";
      default: return "border-indigo-200 text-indigo-500 bg-indigo-50/30";
    }
  };

  return (
    <div className={`min-h-screen font-sans pb-32 transition-colors duration-300 ${isDark ? 'bg-slate-900 text-slate-100' : 'bg-[#F9FAFB] text-slate-800'}`}>
      
      {/* 🌟 폰 상단바 피하기 로직 유지 */}
      {/* 🌟 안드로이드/iOS 상단바(노치/펀치홀)를 자동으로 감지해서 피하는 궁극의 코드! */}
      <div 
        className="flex justify-center items-center px-5 pb-5 mb-2"
        style={{ 
          // 앱일 때는 기기의 안전 영역(상단바)만큼 띄우고, 추가로 20px 더 여유를 줍니다!
          // 웹일 때는 그냥 깔끔하게 24px(1.5rem)만 띄웁니다.
          paddingTop: isApp ? 'calc(env(safe-area-inset-top, 40px) + 20px)' : '24px' 
        }}
      >
        <h1 className="text-2xl font-bold text-indigo-600 tracking-wide">{t.title}</h1>
      </div>

      <div className="px-5">
        
        {activeTab === 'home' && (
          <div className="animate-fade-in">
            <div className={`rounded-[2rem] p-8 shadow-sm mb-6 border flex flex-col items-center justify-center ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200'}`}>
              <label className={`flex flex-col items-center justify-center w-full border-2 border-dashed rounded-[2rem] p-10 cursor-pointer transition-colors ${isDark ? 'border-slate-600 hover:border-indigo-400' : 'border-slate-300 hover:border-indigo-400'}`}>
                <span className="text-4xl mb-3">📸</span>
                <span className={`font-medium ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>{t.select}</span>
                <input type="file" multiple className="hidden" onChange={(e) => setImages(e.target.files)} />
              </label>
            </div>

            {/* 🌟 버튼에 은은한 파란색 그림자(Glow) 추가 */}
            <button 
              onClick={handleAnalyze} disabled={loading}
              className="w-full mb-8 bg-indigo-600 text-white py-4 rounded-full font-bold text-lg shadow-[0_4px_14px_0_rgba(79,70,229,0.39)] hover:shadow-[0_6px_20px_rgba(79,70,229,0.23)] hover:bg-indigo-700 disabled:bg-indigo-400 transition-all flex items-center justify-center gap-2"
            >
              {loading ? t.analyzing : t.analyze}
            </button>

            <div className={`rounded-[2.5rem] p-6 shadow-sm border mb-8 ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-100'}`}>
              <h2 className="text-xl font-extrabold mb-5 flex items-center gap-2">
                <span className="text-2xl">🔍</span> {t.result}
              </h2>
              
              {ingredients.length > 0 ? (
                <div className="flex flex-wrap gap-2 mb-6">
                  {ingredients.map((item, idx) => (
                    <span key={idx} className={`border px-4 py-1.5 rounded-full text-sm font-semibold flex items-center gap-1 ${getBadgeStyle(item.status)}`}>
                      {item.name}
                      {item.note && <span className="text-xs font-medium">({item.note})</span>}
                    </span>
                  ))}
                </div>
              ) : <p className="text-sm opacity-60 mb-4">{t.empty}</p>}

              {/* 🌟 스티치 디자인: 인풋 창 배경색 변경 및 둥근 플러스 버튼 */}
              <div className="relative flex items-center mt-2 mb-4">
                <input 
                  type="text" 
                  value={customInput} 
                  onChange={(e) => setCustomInput(e.target.value)} 
                  placeholder="예: 간장, 양파..." 
                  className={`w-full px-5 py-4 rounded-full text-sm outline-none border-none pr-14 ${isDark ? 'bg-slate-700 text-white' : 'bg-[#F3F4F6] text-slate-700'}`}
                />
                <button onClick={addCustomIngredient} className="absolute right-2 bg-indigo-600 text-white w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold shadow-md hover:bg-indigo-700">
                  +
                </button>
              </div>

              {unknowns.length > 0 && (
                <p className="text-xs text-red-500 font-medium px-2 flex items-start gap-1">
                  <span className="text-sm">❓</span> 
                  <span>AI가 잘 모르는 재료가 있어요: <span className="font-bold">[{unknowns.join(', ')}]</span></span>
                </p>
              )}
            </div>
          </div>
        )}

        {activeTab === 'recommend' && (
          <div className="animate-fade-in space-y-6">
            <h2 className="text-2xl font-black ml-2 mb-6 text-indigo-600 flex items-center gap-2">
              <span>🍴</span> {t.historyTitle}
            </h2>
            {recipeHistory.length === 0 ? (
              <div className={`text-center p-10 rounded-[2.5rem] border ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-100'}`}>
                <span className="text-4xl mb-4 block">📭</span>
                <p className="opacity-60">{t.emptyHistory}</p>
              </div>
            ) : (
              recipeHistory.map((history, hIdx) => (
                <div key={hIdx} className="mb-8">
                  <div className="flex items-center gap-2 mb-4 ml-2 opacity-80">
                    <span className="text-xs font-bold bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full">{history.date}</span>
                  </div>
                  <div className="space-y-4">
                    {history.recipes.map((recipe, idx) => (
                      <div key={idx} className={`rounded-[2.5rem] p-6 shadow-sm border relative ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200'}`}>
                        {/* 🌟 스티치 디자인: 초록색 둥근 뱃지 */}
                        {recipe.time && <span className="absolute top-6 right-6 bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1">⏱️ {recipe.time}</span>}
                        <h3 className="text-2xl font-black mb-3 pr-16">{recipe.name}</h3>
                        <p className="text-sm opacity-70 leading-relaxed mb-6">{recipe.desc}</p>
                        <button onClick={() => saveToReminder(recipe)} className={`w-full border border-slate-200 py-3 rounded-full font-bold text-sm flex items-center justify-center gap-2 transition-colors ${isDark ? 'border-slate-600 hover:bg-slate-700 text-white' : 'hover:bg-slate-50 text-slate-700'}`}>
                          ⏰ {t.reminder}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {activeTab === 'settings' && (
          <div className="animate-fade-in space-y-4">
            <h2 className="text-2xl font-black ml-2 mb-6 text-indigo-600 flex items-center gap-2">
              <span>⚙️</span> {t.settingTitle}
            </h2>
            <div className={`rounded-[2rem] p-6 shadow-sm border flex justify-between items-center ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-100'}`}>
              <div className="flex items-center gap-3">
                <span className="text-2xl">🌐</span>
                <span className="font-bold">{t.langMode}</span>
              </div>
              <button onClick={() => setLang(lang === 'ko' ? 'en' : 'ko')} className="bg-indigo-100 text-indigo-700 px-4 py-2 rounded-full text-sm font-bold">{t.langToggle}</button>
            </div>
            <div className={`rounded-[2rem] p-6 shadow-sm border flex justify-between items-center ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-100'}`}>
              <div className="flex items-center gap-3">
                <span className="text-2xl">🎨</span>
                <span className="font-bold">{t.themeMode}</span>
              </div>
              <button onClick={() => setIsDark(!isDark)} className={`text-2xl px-4 py-1 rounded-full transition-colors ${isDark ? 'bg-slate-700' : 'bg-slate-100'}`}>{isDark ? '🌙' : '☀️'}</button>
            </div>
          </div>
        )}
      </div>

      {/* 📱 🌟 스티치 디자인: 모던 플로팅 바텀 네비게이션 🌟 */}
      <div className="fixed bottom-6 left-6 right-6 z-50 flex justify-center">
        <div className={`
          flex justify-around items-center w-full max-w-md py-3 px-4 
          rounded-[2.5rem] shadow-[0_8px_30px_rgb(0,0,0,0.12)] border transition-all duration-500
          ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-white'}
        `}>
          
          {/* 🌟 수정됨: isDark 조건에 따라 선택된 탭의 배경색과 글자색이 우아하게 바뀝니다! */}
          <div onClick={() => setActiveTab('home')} className={`flex flex-col items-center cursor-pointer transition-all duration-300 w-20 py-2 rounded-2xl ${activeTab === 'home' ? (isDark ? 'bg-indigo-500/20 text-indigo-300' : 'bg-indigo-50 text-indigo-600') : 'text-slate-400 hover:text-indigo-400'}`}>
            <Icons.Fridge active={activeTab === 'home'} />
            <span className="text-[10px] font-bold mt-1">{t.tabHome}</span>
          </div>
          
          <div onClick={() => setActiveTab('recommend')} className={`flex flex-col items-center cursor-pointer transition-all duration-300 w-20 py-2 rounded-2xl ${activeTab === 'recommend' ? (isDark ? 'bg-indigo-500/20 text-indigo-300' : 'bg-indigo-50 text-indigo-600') : 'text-slate-400 hover:text-indigo-400'}`}>
            <Icons.List active={activeTab === 'recommend'} />
            <span className="text-[10px] font-bold mt-1">{t.tabRec}</span>
          </div>
          
          <div onClick={() => setActiveTab('settings')} className={`flex flex-col items-center cursor-pointer transition-all duration-300 w-20 py-2 rounded-2xl ${activeTab === 'settings' ? (isDark ? 'bg-indigo-500/20 text-indigo-300' : 'bg-indigo-50 text-indigo-600') : 'text-slate-400 hover:text-indigo-400'}`}>
            <Icons.Settings active={activeTab === 'settings'} />
            <span className="text-[10px] font-bold mt-1">{t.tabSet}</span>
          </div>

        </div>
      </div>

    </div>
  );
}

export default App;